var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRectLg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "gradient_rect_lg",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 532.69 229.59",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -414.63,
    y1: 503.21,
    x2: -414.63,
    y2: 502.21,
    gradientTransform: "matrix(228.03, 0, 0, -532.08, 94816.49, 267600.76)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#58076b",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#32007e",
    stopOpacity: 0
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "rect-lg") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    x: 153.92,
    y: -147.55,
    width: 228.03,
    height: 532.08,
    rx: 16,
    transform: "translate(147.02 382.36) rotate(-89.82)",
    style: {
      fill: "url(#linear-gradient)"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRectLg);
export default __webpack_public_path__ + "static/media/rect-lg.a18aaf991d4050f848abe29dae3b46af.svg";
export { ForwardRef as ReactComponent };